import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-i18next';
import Navigation from '../components/Navigation';
import OTDTable from '../components/OTDTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';

import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    FormGroup,
    InputGroup
} from 'react-bootstrap';

import './OTD.css';

class OTD extends Component {
    constructor(props) {
        super(props);

        this.handleKeyDown = this.handleKeyDown.bind(this);

        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            onthisdays: [],
            page: props.page,
            pageCount: 0,
            limit: 40,
            cursor: 0,
            result: [],
            search: props.search,
            selected: props.selected - 1
        };
    }

    handleKeyDown(e) {
        const { cursor, result } = this.state;
        // arrow up/down button should select next/previous list element
        console.log(e.key);
        if (e.key === 'ArrowRight') {
            if (this.state.page + 1 > this.state.pageCount) {
                return;
            }
            this.setState(
                prevState => ({
                    page: prevState.page + 1
                }),
                () => {
                    this.loadOTDFromServer();
                }
            );
        } else if (e.key === 'ArrowLeft') {
            if (this.state.page - 1 <= 0) {
                return;
            }

            this.setState(
                prevState => ({
                    page: prevState.page - 1
                }),
                () => {
                    this.loadOTDFromServer();
                }
            );
        }
    }

    componentDidMount() {
        this.loadOTDFromServer();
    }

    loadOTDFromServer() {
        var self = this;
        axios
            .get(`${config.baseURL}/onthisday`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    onthisdays: response.data.onthisdays,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadOTDFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');

        }
        window.history.pushState(null, null, url); 

        event.preventDefault();
        this.loadOTDFromServer();
    };

    deleteOTDFact(fact) {
        var self = this;
        axios
            .delete(`${config.baseURL}/onthisday/${fact.id}`)
            .then(function(response) {
                self.loadOTDFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t('OTD.title')}`;

        return (
            <div className="OTD" onKeyDown={this.handleKeyDown}>
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('OTD.title')}
                                    <Link
                                        type="submit"
                                        className="btn btn-primary"
                                        to="/otd/create"
                                    >
                                        <em className="fa fa-plus fa-fw" />{' '}
                                        {t('OTD.add_fact')}
                                    </Link>
                                </h1>

                                <ol className="breadcrumb">
                                    <li className="active">
                                        <i className="far fa-calendar-alt" />{' '}
                                        {t('OTD.title')}
                                    </li>
                                </ol>

                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <form
                                                    role="search"
                                                    onSubmit={this.handleSubmit}
                                                >
                                                    <FormGroup controlId="search">
                                                        <InputGroup>
                                                            <FormControl
                                                                type="text"
                                                                value={
                                                                    this.state
                                                                        .search
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                                placeholder={t(
                                                                    'Search'
                                                                )}
                                                            />
                                                            <InputGroup.Button>
                                                                <Button
                                                                    onClick={
                                                                        this
                                                                            .handleSubmit
                                                                    }
                                                                >
                                                                    <i className="glyphicon glyphicon-search" />
                                                                </Button>
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </form>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={3}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            forcePage={this.state.selected}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                        />
                                    }
                                >
                                    <OTDTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        otds={this.state.onthisdays}
                                        onDelete={this.deleteOTDFact.bind(this)}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(OTD);
